var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('canvas',{attrs:{"id":"trendChart","width":"900","height":"300"}})])
}]

export { render, staticRenderFns }